import { t } from 'ttag';

const INFO = {
  en: {
    phone: '+45 33 25 08 03',
    email: 'support@unisportstore.com',
    address: 'Vimmelskaftet 42',
    postalcode: '1161',
    city: t`Copenhagen`,
    country: t`Denmark`,
    storeName: t`Copenhagen`,
    storeSubtitle: 'Strøget',
  },
  da: {
    phone: '33 25 08 03',
    flagshipPhone: '33 25 08 03',
    email: 'unisport@unisport.dk',
    address: 'Vimmelskaftet 42, ',
    postalcode: '1161',
    city: t`Copenhagen`,
    country: t`Denmark`,
    storeName: t`Copenhagen`,
    storeSubtitle: 'Strøget',
  },
  fr: {
    phone: '01 87 65 10 40',
    flagshipPhone: '01 40 26 39 20',
    email: 'support@unisportstore.fr',
    address: '4 rue Berger',
    postalcode: '75001',
    city: t`Paris`,
    country: t`France`,
    storeName: t`Paris`,
    storeSubtitle: 'Les Halles',
  },
  nb: {
    phone: '+47 21 40 33 00',
    email: 'support@unisportstore.no',
    address: 'Sognsveien 75 A, 1. etasje',
    postalcode: '0855',
    city: t`Oslo`,
    country: t`Norway`,
    storeName: t`Oslo`,
    storeSubtitle: 'Ullevaal Stadion',
  },
  sv: {
    phone: '0158 800 803',
    email: 'support@unisportstore.se',
    address: 'Sveavägen 2',
    postalcode: '111 57',
    city: t`Stockholm`,
    country: t`Sweden`,
    storeName: t`Stockholm`,
    storeSubtitle: 'Sergelstorg',
  },
  'de-AT': {
    phone: '0720 116237',
    email: 'support@unisportstore.at',
  },
  de: {
    phone: '+49 800 0010189',
    email: 'support@unisportstore.de',
  },
  fi: {
    phone: 'support@unisportstore.fi',
    email: '09 3157 9091',
  },
  nl: {
    phone: '+31 (0)20-262 36 86',
    email: 'support@unisportstore.nl',
  },
};

export default INFO;
